import React from 'react';

import Screen, {backButton, useRetryButton} from 'editor/screens/Screen';
import styles from 'editor/screens/Screen.module.scss';
import loading from 'images/animated/loading.svg';
import {COPY} from 'text/errors';

/**
 * A project the pipeline is still detecting (DQ17), or whose conversion waits for that. The poll runs in openProject and the screen goes when
 * the project settles. `takingLonger` is the 300 s budget spent: the poll has stopped, so the indicator goes and Retry and Back come.
 */
export default function Processing({takingLonger = false}) {
    const retry = useRetryButton();
    const copy = COPY.screens.processing;

    return (
        <Screen title={copy.title} body={takingLonger ? [copy.body, copy.takingLonger] : [copy.body]} buttons={takingLonger ? [retry, backButton] : []}>
            {!takingLonger && <img className={styles.indicator} src={loading} alt=""/>}
        </Screen>
    );
}
